export const LAZYLOADING_METHODS = {
  Waypoint: 'Waypoint',
  GoogleTag: 'GoogleTag'
};
export default {
  LAZYLOADING_METHODS
};